export const urls = {
  login: '/login',
  customerFacingDashboard: '/dashboard',
  internalDashboard: '/admin/dashboard',
  agent: '/datasafra-agent',
  // Não é uma rota do Angular Router: é servido como app estático separado pelo backend (ver backend/src/server/index.ts).
  instructionManual: '/manual',
};
